import { __extends, __decorate, __metadata } from 'tslib';
import { Model, Prop, Component, Vue } from 'vue-property-decorator';
import 'reflect-metadata';
import clsx from 'clsx';
import __vue_component__$1 from './HseModalPortal.vue.js';
import __vue_component__ from './HseBaseModal.vue.js';

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=4123%3A9057
 * @storybook /?path=/story/modal-modalform--playground
 * @react /src-components-modal
 * @reactStorybook /?path=/story/modal-modalform--playground
 * @requires ./HseBaseModal.vue
 * @requires ./HseModalForm.vue
 * @requires ./HseModalInfo.vue
 * @requires ./HseModalOverlay.vue
 * @requires ./HseModalPortal.vue
 * @requires ./HseModalStatus.vue
 * @example ./HseModalForm.md
 * @example ./HseModalInfo.md
 * @example ./HseModalStatus.md
 */
var HseModal = /** @class */ (function (_super) {
    __extends(HseModal, _super);
    function HseModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(HseModal.prototype, "modalClassComputed", {
        get: function () {
            return clsx('hse-Modal', this.modalClass);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Model('toggle'),
        __metadata("design:type", Boolean)
    ], HseModal.prototype, "open", void 0);
    __decorate([
        Prop({
            default: true
        }),
        __metadata("design:type", Boolean)
    ], HseModal.prototype, "shouldCloseOnOverlayClick", void 0);
    __decorate([
        Prop({
            default: true
        }),
        __metadata("design:type", Boolean)
    ], HseModal.prototype, "shouldCloseOnEsc", void 0);
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", Object)
    ], HseModal.prototype, "modalClass", void 0);
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", Object)
    ], HseModal.prototype, "modalStyle", void 0);
    HseModal = __decorate([
        Component({
            name: 'HseModal',
            components: { HseBaseModal: __vue_component__, HseModalPortal: __vue_component__$1 },
        })
    ], HseModal);
    return HseModal;
}(Vue));

export default HseModal;
